import Component from '@glimmer/component';
import breev from 'embroil/helpers/breev';
import { formatDate } from '../../../helpers/format-date';
import { LinkTo } from '@ember/routing';

export default class MatchResult extends Component {
  get teamA() {
    return this.args.match.teams[0];
  }

  get teamB() {
    return this.args.match.teams[1];
  }

  get currentScore() {
    const victories = this.args.match.rounds.map((round) => {
      return round?.victor?.slug;
    });

    let teamAScore = 0;
    let teamBScore = 0;

    victories.forEach((victor) => {
      if (victor === this.teamA.slug) {
        teamAScore++;
      } else if (victor === this.teamB.slug) {
        teamBScore++;
      }
    });

    return { a: teamAScore, b: teamBScore };
  }
  <template>
    <div class='carousel-match-result-item'>
      <div class='widget-match-result hoverable'>
        <div class='widget-match-result-item'>
          <div class='team-info-wrap'>
            <img class='team-logo small' src='{{this.teamA.logo.url}}' alt='logo-03' />
            <div class='team-info'>
              <p class='team-name'>{{breev this.teamA.name}} </p>
              <p class='team-country'></p>
            </div>
          </div>
          <p class='match-score'>{{this.currentScore.a}}</p>
          {{#if @match.isLive}}
            <p class='match-datetime live'>LIVE</p>
          {{else if @match.isFinal}}
            <p class='match-datetime'>FINAL</p>
          {{else if @match.scheduledDate}}
            <p class='match-datetime'>{{formatDate @match.scheduledDate 'MM/DD'}}</p>
          {{else}}
            <p class='match-datetime'>TBD</p>
          {{/if}}
        </div>
        <div class='widget-match-result-item'>
          <div class='team-info-wrap'>
            <img class='team-logo small' src='{{this.teamB.logo.url}}' alt='logo-04' />
            <div class='team-info'>
              <p class='team-name'>{{breev this.teamB.name}}</p>
              <p class='team-country'></p>
            </div>
          </div>
          <p class='match-score'>{{this.currentScore.b}}</p>

          {{#if @match.isLive}}
            <p class='match-datetime light'>{{formatDate @match.scheduledDate 'hA'}}</p>

          {{else if @match.isFinal}}
            {{#if @match.scheduledDate}}
              <p class='match-datetime light'>{{formatDate @match.scheduledDate 'MM/DD'}}</p>
            {{else}}
              <p class='match-datetime light'>TBD</p>
            {{/if}}
          {{else if @match.scheduledDate}}
            <p class='match-datetime'>{{formatDate @match.scheduledDate 'hA'}}</p>
          {{else}}
            <p class='match-datetime'>TBD</p>
          {{/if}}
        </div>
        <div class='widget-match-result-actions'>
          <LinkTo @route='esports.matches.match' @model={{@match.slug}} class='widget-match-result-action'>
            <svg class='play-button-icon tiny'>
              <use href='#svg-play'></use>
            </svg>
            {{#if @match.isLive}}
              Watch Live
            {{else if @match.isFinal}}
              Replay
            {{else}}
              Watch Live
            {{/if}}
          </LinkTo>
          {{!--<LinkTo @route='esports.matches.match' @model={{@match.slug}} class='widget-match-result-action'>
            <p class='widget-match-result-action popup-watch-video-trigger'>
              <svg class='bars-icon'>
                <use href='#svg-bars'></use>
              </svg>
              Stats
            </p>
          </LinkTo>--}}
        </div>
      </div>
    </div>
  </template>
}
